define('utils/jquery-rotate',['jquery', 'commons/message-manager'], function($, messages) {
    $.fn.rotate = function(degrees) {
        $(this).css({
            '-webkit-transform' : 'rotate(' + degrees + 'deg)',
            '-moz-transform' : 'rotate(' + degrees + 'deg)',
            '-ms-transform' : 'rotate(' + degrees + 'deg)',
            'transform' : 'rotate(' + degrees + 'deg)'
        });
    };
});

